/**
 * Mock employees for assignment & filters (CA firm).
 */
export const employees = [
  { id: 'emp-1', name: 'Priya Sharma', role: 'Senior Associate' },
  { id: 'emp-2', name: 'Rahul Mehta', role: 'Manager' },
  { id: 'emp-3', name: 'Anita Desai', role: 'Partner' },
  { id: 'emp-4', name: 'Vikram Singh', role: 'Associate' },
]

/** Pipeline / inquiry statuses */
export const INQUIRY_STATUSES = [
  'New',
  'Assigned',
  'Contacted',
  'Follow-up',
  'Qualified',
  'Converted',
  'Lost',
]

export const services = [
  'Income Tax Filing',
  'GST Registration & Compliance',
  'Audit & Assurance',
  'ROC Filings',
  'Bookkeeping',
  'Tax Planning',
  'Startup Advisory',
]

export const sources = [
  'Website',
  'Referral',
  'Walk-in',
  'LinkedIn',
  'Google Ads',
  'Existing Client',
]

export const priorities = ['Hot', 'Warm', 'Cold']

export const followUpTypes = ['Call', 'Email', 'Meeting', 'WhatsApp', 'Other']

export const followUpOutcomes = [
  'No Answer',
  'Interested',
  'Callback Requested',
  'Not Interested',
  'Proposal Sent',
  'Converted',
]

/**
 * Initial inquiries — varied statuses for list, pipeline, and dashboard.
 */
export const initialInquiries = [
  {
    id: 'inq-1',
    name: 'Neha Kapoor',
    phone: '+91 98765 43210',
    email: 'neha.k@example.com',
    service: 'Income Tax Filing',
    source: 'Website',
    priority: 'Hot',
    status: 'Follow-up',
    assignedTo: 'emp-1',
    nextFollowUpDate: '2026-04-08',
    remarks: 'FY 25-26 return; salaried individual.',
    createdAt: '2026-03-15T10:00:00.000Z',
  },
  {
    id: 'inq-2',
    name: 'Arjun Patel',
    phone: '+91 91234 56789',
    email: 'arjun.patel@startup.io',
    service: 'GST Registration & Compliance',
    source: 'Referral',
    priority: 'Warm',
    status: 'Qualified',
    assignedTo: 'emp-2',
    nextFollowUpDate: '2026-04-10',
    remarks: 'E-commerce seller; needs monthly GST.',
    createdAt: '2026-03-20T14:30:00.000Z',
  },
  {
    id: 'inq-3',
    name: 'Sunita Reddy',
    phone: '+91 99887 76655',
    email: 'sunita.r@family.com',
    service: 'Tax Planning',
    source: 'Walk-in',
    priority: 'Cold',
    status: 'New',
    assignedTo: null,
    nextFollowUpDate: null,
    remarks: '',
    createdAt: '2026-04-05T09:15:00.000Z',
  },
  {
    id: 'inq-4',
    name: 'Kabir Khan',
    phone: '+91 98100 11223',
    email: 'kabir@designstudio.in',
    service: 'Bookkeeping',
    source: 'LinkedIn',
    priority: 'Warm',
    status: 'Contacted',
    assignedTo: 'emp-4',
    nextFollowUpDate: '2026-04-12',
    remarks: 'Small agency; quarterly books.',
    createdAt: '2026-04-01T11:00:00.000Z',
  },
  {
    id: 'inq-5',
    name: 'Meera Iyer',
    phone: '+91 97654 32109',
    email: 'meera.iyer@corp.in',
    service: 'Audit & Assurance',
    source: 'Existing Client',
    priority: 'Hot',
    status: 'Assigned',
    assignedTo: 'emp-3',
    nextFollowUpDate: '2026-04-09',
    remarks: 'Statutory audit discussion.',
    createdAt: '2026-04-04T16:45:00.000Z',
  },
  {
    id: 'inq-6',
    name: 'Rohan Bhatt',
    phone: '+91 93456 78901',
    email: 'rohan.b@gmail.com',
    service: 'ROC Filings',
    source: 'Google Ads',
    priority: 'Cold',
    status: 'Lost',
    assignedTo: 'emp-1',
    nextFollowUpDate: null,
    remarks: 'Chose another firm.',
    createdAt: '2026-02-10T08:00:00.000Z',
  },
  {
    id: 'inq-7',
    name: 'Divya Nair',
    phone: '+91 94567 89012',
    email: 'divya.nair@tech.co',
    service: 'Startup Advisory',
    source: 'Website',
    priority: 'Hot',
    status: 'Converted',
    assignedTo: 'emp-2',
    nextFollowUpDate: null,
    remarks: 'Onboarded as retainer client.',
    createdAt: '2026-01-22T13:20:00.000Z',
  },
]

/**
 * Follow-ups keyed by inquiryId in app state; flat list for mock seed.
 */
export const initialFollowUps = [
  {
    id: 'fu-1',
    inquiryId: 'inq-1',
    date: '2026-03-16T11:00:00.000Z',
    type: 'Call',
    notes: 'Discussed documents needed for ITR.',
    outcome: 'Callback Requested',
    nextFollowUpDate: '2026-03-25',
  },
  {
    id: 'fu-2',
    inquiryId: 'inq-1',
    date: '2026-03-25T15:30:00.000Z',
    type: 'Email',
    notes: 'Sent checklist for Form 16 and 26AS.',
    outcome: 'Interested',
    nextFollowUpDate: '2026-04-08',
  },
  {
    id: 'fu-3',
    inquiryId: 'inq-2',
    date: '2026-03-21T10:00:00.000Z',
    type: 'Meeting',
    notes: 'Office visit; reviewed GST turnover.',
    outcome: 'Proposal Sent',
    nextFollowUpDate: '2026-04-10',
  },
  {
    id: 'fu-4',
    inquiryId: 'inq-4',
    date: '2026-04-02T09:00:00.000Z',
    type: 'WhatsApp',
    notes: 'Shared engagement letter draft.',
    outcome: 'Interested',
    nextFollowUpDate: '2026-04-12',
  },
]
